import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getEmissionFactors(params = {}) {
  const { type, page = 0, limit = 5 } = params;
  let url = URL.buildUrl("emissionFactors");
  let queryString = `page=${page}&limit=${limit}`;
  const filterType = type && type.length > 0 ? type : [];
  queryString += `&filter=${JSON.stringify({ type: filterType })}`;

  return await new API(`${url}?${queryString}`).get();
}
